module.exports = __webpack_public_path__ + "img/image91.896d4357.jpg";